import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/helpharma.png'


const _hoisted_1 = { class: "login-box" }
const _hoisted_2 = { class: "card card-outline card-primary" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-header text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    srcset: ""
  })
], -1)
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "login-box-msg" }, " Usted no tiene permiso para acceder a esta página ", -1)
const _hoisted_6 = { class: "mb-1 mt-3" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Cerrar sesion ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Volver al dashboard ")

export function render(_ctx, _cache) {
  const _component_app_button = _resolveComponent("app-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("p", _hoisted_6, [
          (_ctx.token)
            ? (_openBlock(), _createBlock(_component_app_button, {
                key: 0,
                onClick: _ctx.logout,
                class: "btn btn-light btn-flat float-right",
                block: true,
                loading: _ctx.isLogoutLoading
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["onClick", "loading"]))
            : _createCommentVNode("", true),
          (_ctx.token && _ctx.ability.can('VIGIFLOW.LISTAR', 'VIGIFLOW'))
            ? (_openBlock(), _createBlock(_component_app_button, {
                key: 1,
                onClick: _ctx.backToDashboard,
                class: "btn btn-primary btn-flat float-right",
                block: true
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}